import { render, staticRenderFns } from "./PayDistributionModal.vue?vue&type=template&id=c0408a44&scoped=true"
import script from "./PayDistributionModal.vue?vue&type=script&lang=js"
export * from "./PayDistributionModal.vue?vue&type=script&lang=js"
import style0 from "./PayDistributionModal.vue?vue&type=style&index=0&id=c0408a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0408a44",
  null
  
)

export default component.exports